import { WorkshiftsListModel } from '../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';

/**
 * Esta función se encarga de saber que programaciones coinciden con un empleado y con la fecha y la devuelve
 * @param date string | number
 * @param employeeID string | number
 * @param workshiftShedulingList WorkshiftsListModel
 * @returns La programación del turno o nada  WorkshiftSchedulingModel | undefined
 */
export const getWorkshiftScheduling = (
    date: string | number,
    employeeID: string | number,
    workshiftShedulingList: WorkshiftsListModel
) => {
    if (workshiftShedulingList.schedulings) {
        const records = workshiftShedulingList.schedulings.filter(
            (emp) => emp.employeeId === employeeID
        );

        let resultDate = records.find((record) => {
            return record.date.split('T')[0] === date;
        });

        return resultDate;
    }
};
